module.exports = __webpack_public_path__ + "files/2664ec19489bc1e90d00e91af6cb75d9.png";